import { Tag as ChakraTag, TagRootProps } from '@chakra-ui/react/tag'
import * as React from 'react'

type TagProps = TagRootProps & {
  startElement?: React.ReactNode
  endElement?: React.ReactNode
  onClose?: () => void
  closable?: boolean
}

export const Tag = React.forwardRef(function Tag(props: TagProps, ref: React.Ref<HTMLDivElement>) {
  const { startElement, endElement, onClose, closable = !!onClose, children, ...rest } = props

  return (
    <ChakraTag.Root ref={ref} {...rest}>
      {startElement && <ChakraTag.StartElement>{startElement}</ChakraTag.StartElement>}
      <ChakraTag.Label>{children}</ChakraTag.Label>
      {endElement && <ChakraTag.EndElement>{endElement}</ChakraTag.EndElement>}
      {closable && (
        <ChakraTag.EndElement>
          <ChakraTag.CloseTrigger onClick={onClose} />
        </ChakraTag.EndElement>
      )}
    </ChakraTag.Root>
  )
})
